/* eslint-disable */

export enum PERMISSION {
  CUSTOMER_USERS_CREATE = 'CUSTOMER_USERS_CREATE',

  ALLOCATION_WORKBENCH_MODULE_ENTRY = 'ALLOCATION_WORKBENCH_MODULE_ENTRY',

  COMMENT_LIST = 'COMMENT_LIST',
  COMMENT_CREATE = 'COMMENT_CREATE',

  CV_BOOKING_APPROVE = 'CV_BOOKING_APPROVE',
  CV_BOOKING_DECLINE = 'CV_BOOKING_DECLINE',
  CV_BOOKING_ALL_LIST = 'CV_BOOKING_ALL_LIST',
  CUSTOMER_BOOKINGS_CREATE = 'CUSTOMER_BOOKINGS_CREATE',
  CUSTOMER_BOOKINGS_LIST = 'CUSTOMER_BOOKINGS_LIST',
  CV_BOOKING_CREATE = 'CV_BOOKING_CREATE',
  CV_BOOKING_MY_LIST = 'CV_BOOKING_MY_LIST',
  CV_BOOKING_UPDATE = 'CV_BOOKING_UPDATE',

  CV_MODULE_ENTRY = 'CV_MODULE_ENTRY',
  LIST_EMPLOYEE_CV = 'LIST_EMPLOYEE_CV',
  DETAILS_EMPLOYEE_CV = 'DETAILS_EMPLOYEE_CV',

  DASHBOARD_MODULE_ENTRY = 'DASHBOARD_MODULE_ENTRY',

  PROJECTS_MODULE_ENTRY = 'PROJECTS_MODULE_ENTRY',
  CUSTOMER_PROJECTS_LIST = 'CUSTOMER_PROJECTS_LIST',

  REPORTING_MODULE_ENTRY = 'REPORTING_MODULE_ENTRY',

  DOCUMENTS_MODULE_ENTRY = 'DOCUMENTS_MODULE_ENTRY',

  CSATS_MODULE_ENTRY = 'CSATS_MODULE_ENTRY',

  CONSULTANT_SETTINGS_TAB_ENTRY = 'CONSULTANT_SETTINGS_TAB_ENTRY',
  ADMIN_IMPERSONATE = 'ADMIN_IMPERSONATE',
}

export const tenantConfig = {
  cloudia: {
    title: 'Cloudia 2.0',
    faviconUrl: '/assets/favicons/cloudia-favicon.png',
    logoUrl: '/assets/images/cloudia-logo.svg',
    logoSmall: '/assets/images/cloudia-only-c.svg',
    defaultMeetingTitle: 'Meeting',
  } as TenantConfig,
};

export interface TenantConfig {
  logoUrl: string;
  logoSmall: string;
  faviconUrl: string;
  title: string;
  guestPermissions: string[];
  defaultMeetingTitle: string;
}
